import { useNavigate } from 'react-router-dom'

import { Button } from '@/components'
import { Trans } from '@/components'
import { EmptyView } from '@/components/EmptyView'

export function InsufficientQuotaView() {
  const navigate = useNavigate()

  return (
    <EmptyView
      title={
        <Trans i18nKey="data.insufficientQuotaAvailableTitle">Insufficient quota available</Trans>
      }
      content={
        <Trans i18nKey="data.insufficientQuotaAvailableContent">
          Update your quota settings in Storage Capacity to proceed
        </Trans>
      }
      action={
        <Button type="secondary" onClick={() => navigate('/space')}>
          <Trans i18nKey="data.emptyViewActionBtn">Manage Capacity</Trans>
        </Button>
      }
    />
  )
}
